import { NotificationSeverity } from '@/components/notifications/Notification';
import type { IntegrationDocData } from '../utils/integrationDocData';
import { useDownloadDocs, useNotification } from '@/hooks';
import { useState } from 'react';

const fileNameFor = (commerceName: string): string => {
  const slug = commerceName
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  return `Integracion-API-${slug || 'comercio'}.pdf`;
};

const useIntegrationDocDownload = () => {
  const { showNotification } = useNotification();
  const { downloadDocs } = useDownloadDocs();
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadDoc = async (data: IntegrationDocData) => {
    setIsDownloading(true);
    try {
      const [{ buildIntegrationDocContent }, { buildIntegrationDocPdf }] = await Promise.all([
        import('../utils/integrationDocContent'),
        import('../utils/buildIntegrationDocPdf'),
      ]);
      const blob = buildIntegrationDocPdf(buildIntegrationDocContent(data));
      const url = URL.createObjectURL(blob);
      downloadDocs(url, fileNameFor(data.commerceName));
      URL.revokeObjectURL(url);
    } catch {
      showNotification(
        'No se pudo generar la documentación. Intente de nuevo.',
        NotificationSeverity.error
      );
    } finally {
      setIsDownloading(false);
    }
  };

  return { downloadDoc, isDownloading };
};

export default useIntegrationDocDownload;
